// import store from '@/store/index.js'
// let dic = store.state.dic;

export default function Configs(that) {

    const searchItems = [
        {
            label: "学院",
            span: 8,
            placeholder: '请选择学院',
            model: "collegeId",
            type: "select",
            options:[],
            clearable: true,
        }
    ]
    const tableColumns = [
        {
            label: "系(院)",
            prop: "collegeName",
            align: "center",
            show: true
        },
        {
            label: "总人数",
            prop: "totalNum",
            align: "center",
            show: true
        },
        // {
        //     label: "缴费审核",
        //     prop: "11",
        //     align: "center",
        //     show: true
        // },
        // {
        //     label: "系(院)报到(一卡通/钥匙领取)",
        //     prop: "11",
        //     align: "center",
        //     show: true
        // },
        // {
        //     label: "入住登记",
        //     prop: "11",
        //     align: "center",
        //     show: true
        // },
        // {
        //     label: "军训服领取",
        //     prop: "11",
        //     align: "center",
        //     show: true
        // },
    ]

    return {
        searchItems,
        tableColumns
    }
}
